import { useState } from "react";
import { ArrowRight } from "lucide-react";
import SectionReveal from "@/components/SectionReveal";
import LeadDialog from "@/components/LeadDialog";

export default function CTABand() {
  const [demoOpen, setDemoOpen] = useState(false);
  const [pilotOpen, setPilotOpen] = useState(false);

  return (
    <SectionReveal as="section"
      className="lf-cta-reveal lf-section bg-ink-900 text-white relative overflow-hidden"
      data-testid="cta-band"
    >
      <div className="absolute inset-0 lf-grid-bg-faint opacity-30 pointer-events-none" />
      <div className="lf-container relative">
        <div className="max-w-3xl">
          <div className="lf-eyebrow text-ink-300">Next step</div>
          <h2 className="mt-5 font-display text-4xl md:text-5xl font-black tracking-tight leading-[1.05]">
            See LightningFlow in action.
          </h2>
          <p className="mt-5 text-lg text-ink-300 leading-relaxed">
            Discover how LightningFlow can secure, simplify and accelerate your network operations.
          </p>

          <div className="mt-8 flex flex-wrap gap-3">
            <button
              type="button"
              onClick={() => setDemoOpen(true)}
              className="lf-btn bg-white text-ink-900 hover:bg-electric hover:text-white border border-white hover:border-electric"
              data-testid="cta-band-request-demo"
            >
              Request a Demo
              <ArrowRight className="h-4 w-4" strokeWidth={1.75} />
            </button>
            <button
              type="button"
              onClick={() => setPilotOpen(true)}
              className="lf-btn bg-transparent text-white border border-white/30 hover:border-white"
              data-testid="cta-band-start-pilot"
            >
              Discuss Your Network
            </button>
          </div>
        </div>
      </div>

      <LeadDialog
        open={demoOpen}
        onOpenChange={setDemoOpen}
        kind="demo"
        title="See LightningFlow in action"
        description="Tell us about your network priorities and we will tailor the conversation."
      />
      <LeadDialog
        open={pilotOpen}
        onOpenChange={setPilotOpen}
        kind="pilot"
        title="Discuss Your Network"
        description="Tell us about your environment, priorities and the outcomes you want to achieve."
      />
    </SectionReveal>
  );
}
